export default "__VITE_ASSET__CErkDdte__"